/** Order, settlement and payment vocabulary shared by the API and the SPA. */

export const SETTLEMENT_TYPES = {
  full: "full",
  downPayment: "down_payment",
} as const;

export type SettlementType = (typeof SETTLEMENT_TYPES)[keyof typeof SETTLEMENT_TYPES];

export const ALL_SETTLEMENT_TYPES: readonly SettlementType[] = [
  SETTLEMENT_TYPES.full,
  SETTLEMENT_TYPES.downPayment,
];

export const ORDER_STATUSES = {
  draft: "draft",
  unpaid: "unpaid",
  partiallyPaid: "partially_paid",
  paid: "paid",
  cancelled: "cancelled",
  completed: "completed",
} as const;

export type OrderStatus = (typeof ORDER_STATUSES)[keyof typeof ORDER_STATUSES];

export const ALL_ORDER_STATUSES: readonly OrderStatus[] = [
  ORDER_STATUSES.draft,
  ORDER_STATUSES.unpaid,
  ORDER_STATUSES.partiallyPaid,
  ORDER_STATUSES.paid,
  ORDER_STATUSES.cancelled,
  ORDER_STATUSES.completed,
];

export const PAYMENT_METHODS = {
  cash: "cash",
  transfer: "transfer",
  qris: "qris",
  other: "other",
} as const;

export type PaymentMethod = (typeof PAYMENT_METHODS)[keyof typeof PAYMENT_METHODS];

export const ALL_PAYMENT_METHODS: readonly PaymentMethod[] = [
  PAYMENT_METHODS.cash,
  PAYMENT_METHODS.transfer,
  PAYMENT_METHODS.qris,
  PAYMENT_METHODS.other,
];

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: "Cash",
  transfer: "Bank transfer",
  qris: "QRIS",
  other: "Other",
};

export const ORDER_CODE = {
  prefix: "ORD",
  separator: "-",
  padding: 5,
  maxSequenceRetries: 3,
} as const;

export const ORDER_DEFAULTS = {
  dueInDays: 7,
  maxLines: 100,
  maxLineQuantity: 999,
  minLineQuantity: 1,
} as const;

/** Payment statuses that still count as receivable in analytics. */
export const OUTSTANDING_ORDER_STATUSES: readonly OrderStatus[] = [
  ORDER_STATUSES.unpaid,
  ORDER_STATUSES.partiallyPaid,
];

export const SETTLEMENT_TYPE_LABELS: Record<SettlementType, string> = {
  full: "Full settlement",
  down_payment: "Down payment",
};

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  draft: "Draft",
  unpaid: "Unpaid",
  partially_paid: "Partially paid",
  paid: "Paid",
  cancelled: "Cancelled",
  completed: "Completed",
};
